import { STRINGS } from '@/strings/strings';
import { cn } from '@/lib/utils';

// Matches Prisma enum SbCategory — must stay in sync with backend.
export type SbCategory =
  | 'alltag_ernaehrung'
  | 'tiere_natur_umwelt'
  | 'technik_erfindungen'
  | 'mensch_koerper'
  | 'universum_wissenschaft'
  | 'welt_kultur';

const CATEGORY_ORDER: SbCategory[] = [
  'alltag_ernaehrung',
  'tiere_natur_umwelt',
  'technik_erfindungen',
  'mensch_koerper',
  'universum_wissenschaft',
  'welt_kultur',
];

interface CategoryChipsProps {
  value: SbCategory | null;
  onChange: (value: SbCategory | null) => void;
}

export function CategoryChips({ value, onChange }: CategoryChipsProps) {
  const labels = STRINGS.builder.sb.categories;

  return (
    <div className="flex flex-wrap gap-2">
      {CATEGORY_ORDER.map((cat) => {
        const isActive = value === cat;
        return (
          <button
            key={cat}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(isActive ? null : cat)}
            className={cn(
              'min-h-11 rounded-full border-[1.5px] px-4 py-2.5 text-sm transition-colors',
              isActive
                ? 'border-dream-gold bg-dream-gold/20 font-bold text-dream-navy'
                : 'border-dream-navy/30 bg-white text-dream-navy',
            )}
          >
            {labels[cat]}
          </button>
        );
      })}
    </div>
  );
}
